import React, { useEffect, useState } from "react";
import Styles from "../../assets/css/components/artistAlbum/albumNavTab.module.scss";
import { RiHeart2Fill } from "react-icons/ri";
import { BsFillBookmarkHeartFill } from "react-icons/bs";
import { FaRegHeart } from "react-icons/fa";
import { PiDotsThreeOutlineFill } from "react-icons/pi";
import ProfileLogo from "../../assets/images/Artist/Album/Track-image.png";
import { LuClock7 } from "react-icons/lu";
import { MdDelete } from "react-icons/md";
import { FaRegEye } from "react-icons/fa";
import DeleteIllustration from "../../assets/images/deleteIllustrator.png";
import { ImHeadphones } from "react-icons/im";
import axios from "axios";
import { baseUrl } from "../../utils/constant";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { popUpBoxTrigger } from "../../features/message/popUpSlice";
import { FaUsers } from "react-icons/fa";
import { convertDuration } from "../../utils/convertFunctions";


const AlbumNavTab = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { albumId } = useParams();
  const [albumListData, setAlbumListData] = useState();
  const [refresh, setRefresh] = useState(0);
  const [sorting, setSorting] = useState("song_desc");
  const globalRef = useSelector((state) => state.globalRefresh.globalRefresh);

  const [dropDownTrackManage, setDropDownTrackManage] = useState({
    id: 0,
    open: false
  });

  const [deleteAlbumDrop, setDeleteAlbumDrop] = useState(false);

  useEffect(() => {

    const token = localStorage.getItem("token");

    const getAlbumListData = async () => {
      try {
        const getAlbumList = await axios.get(`${baseUrl}artist/album/${albumId}?filter=${sorting}`, {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        });
    
        const result = getAlbumList;
        console.log(result);
        if(result.data.status === 200){
          setAlbumListData(result.data.data);
        }
      } catch (error) {
        console.log("Error : ", error);
      }
    }
    getAlbumListData();

  }, [refresh, sorting, globalRef]);

  console.log("Album new : ",albumListData);

  const handleDropDown = (e) => {
    let value = e.currentTarget.dataset.trackId;
    value = Number(value);

    if(dropDownTrackManage.id === value){
      setDropDownTrackManage({...dropDownTrackManage, open: !(dropDownTrackManage.open)})
    }

    if(dropDownTrackManage.id !== value){
      setDropDownTrackManage({id: value, open: true});
    }
  }


  const removeSongToAlbumList = async (track) => {
    
    try {
      const token = localStorage.getItem("token");
      const userData = JSON.parse(localStorage.getItem("user_data"));
      const deleteSong = await axios({
        method: 'POST',
        url: `${baseUrl}artist/album/remove-track`,
        headers: {
          'Authorization': 'Bearer ' + token
        },
        data: {
          "tracks_ids": track,
          "artist_id": userData.id,
          "album_id": albumId
        }
      });
    
      const result = deleteSong;
      if(result.data.status === 200){
        setRefresh(refresh+1);
        setDropDownTrackManage({
          id: 0,
          open: false
        });
        dispatch(popUpBoxTrigger({type: "success", heading: "Success", message: "Track Remove successfully."}));
      }
    } catch (error) {
      if(error){
        dispatch(popUpBoxTrigger({type: "error", heading: "Error", message: "oops!! Something went wrong."}));
      }
    }
    
  }

  return (
    <div className={`${Styles.navtab}`}>

      {
        deleteAlbumDrop && (
        <div className={`${Styles.deleteAlbum}`}>
          <div className={`${Styles.innerDeleteAlbum}`}>
              <div className={`${Styles.heading}`}>
                  <p>Do you really want to delete this album?</p>
              </div>

              <div className={`${Styles.delete_image}`}>
                  <img src={DeleteIllustration} alt="not supported" />
              </div>

              <div className={`${Styles.buttons}`}>
                  <button>Yes, Delete Album</button>
                  <button onClick={() => {setDeleteAlbumDrop(false); setDropDownTrackManage({id: 0, open: false});}}>Skip & Continue</button>
              </div>
          </div>
        </div>
        )
      }

      <div className={`${Styles.navbar}`}>
          <div className={`${Styles.filters}`}>
            <p className={`${Styles.nav_item} ${(sorting === "song_desc") ? Styles.active : ""}`} onClick={(e) => setSorting("song_desc")}>Songs</p>
            <p className={`${Styles.nav_item} ${(sorting === "most_popular") ? Styles.active : ""}`} onClick={(e) => setSorting("most_popular")}>Popular</p>
            <p className={`${Styles.nav_item} ${(sorting === "most_like") ? Styles.active : ""}`} onClick={(e) => setSorting("most_like")}>Most like</p>
          </div>
          <div className={`${Styles.count}`}>
            <div className={`${Styles.song}`}>
              <ImHeadphones />
              <p>{albumListData?.music_count}</p>
            </div>
            <div className={`${Styles.save}`}>
              <BsFillBookmarkHeartFill />
              <p>{albumListData?.saved_count}</p>
            </div>
            <div className={`${Styles.like}`}>
              <RiHeart2Fill />
              <p>{albumListData?.like_count}</p>
            </div>
          </div>
      </div>

      <div className={`${Styles.album_songList}`}>
        <div className={`${Styles.track_table}`}>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Track</th>
                <th>Duration</th>
                <th>Play</th>
                <th>Like</th>
                <th></th>
              </tr>
            </thead>
            <tbody>


              {
                albumListData?.album_tracks.length === 0 &&
                  <tr><td colSpan="6"><div className={`${Styles.dataNotFound}`}>Data Not Found</div></td></tr>
              }

              {
                albumListData?.album_tracks.map((data, index) => {
                  return (
                    <tr>
                      <td>{index+1}</td>
                      <td className={`${Styles.image_name}`}>
                        <div className={`${Styles.image}`}>
                          <img src={data.tracks.cover_image} alt="Track Picture1" />
                        </div>
                        <div className={`${Styles.track_name}`}>
                          <p>{data.tracks.title}</p>
                        </div>
                      </td>
                      <td className={`${Styles.time}`}>
                        <div className={`${Styles.time_div}`}>
                          <LuClock7 />
                          <p>{convertDuration(data.tracks.track_duration)}</p>
                        </div>
                      </td>
                      <td className={`${Styles.play}`}>
                          <div className={`${Styles.play_div}`}>
                            <FaUsers />
                            <p>{data.tracks.play_count}</p>
                          </div>
                      </td>
                      <td className={`${Styles.like}`}>
                        <div className={`${Styles.like_div}`}>
                          <FaRegHeart />
                          <p>{data.like_count}</p>
                        </div>
                      </td>
                      <td>
                        <div className={`${Styles.manage}`}>
                          <PiDotsThreeOutlineFill data-trackId={data.tracks.id} onClick={handleDropDown} />
                          {
                            dropDownTrackManage.id === data.tracks.id && dropDownTrackManage.open === true && (
                              <div className={`${Styles.manageTrack}`}>
                                <p onClick={() => removeSongToAlbumList(data.track_id)}><span><MdDelete /></span> <span>Remove Track</span></p>
                              </div>
                            )
                          }
                        </div>
                      </td>
                    </tr>
                  )
                })
              }

            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default AlbumNavTab
